import $ from 'jquery';
import { getCookie, setCookie } from './shared/cookieHelper';

$(function () {
    $(document).ready(function () {
        var l = getCookie("widgetLanguage");
        if (l == "")
            l = 'en';
       selectLanguageByCode(l);
    });

    if ($('#brand_home_page').length) {
        setTimeout(() => {
            $('#brand_home_page .filter').css('width', '100%');
        }, 250);
    }

    if ($('#languageDropdown').length) {
        document.getElementById('languageDropdown').addEventListener('change', function () {
            let selectedLanguage = this.options[this.selectedIndex].dataset.langCode;
            setCookie("widgetLanguage", selectedLanguage);
            lzSwitchLanguage(selectedLanguage);
        });
    }
    if ($('#languageDropdownmob').length) {
        document.getElementById('languageDropdownmob').addEventListener('change', function () {
            let selectedLanguage = this.options[this.selectedIndex].dataset.langCode;
            setCookie("widgetLanguage", selectedLanguage);
            lzSwitchLanguage(selectedLanguage);
        });
    }
});

window.selectLanguageByCode = function (langCode) {
    const dropdown = document.getElementById("languageDropdown");
    const dropdownmob = document.getElementById("languageDropdownmob");

    const options = dropdown.options;

    for (let i = 0; i < options.length; i++) {
        if (options[i].getAttribute("data-lang-code") === langCode) {
            dropdown.selectedIndex = i;
            break;
        }
    }
    const optionsmob = dropdownmob.options;

    for (let i = 0; i < optionsmob.length; i++) {
        if (optionsmob[i].getAttribute("data-lang-code") === langCode) {
            dropdownmob.selectedIndex = i;
            break;
        }
    }
}
